import { render, staticRenderFns } from "./PoppableItemImage.vue?vue&type=template&id=36a162c6&scoped=true&"
import script from "./PoppableItemImage.vue?vue&type=script&lang=js&"
export * from "./PoppableItemImage.vue?vue&type=script&lang=js&"
import style0 from "./PoppableItemImage.vue?vue&type=style&index=0&id=36a162c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a162c6",
  null
  
)

export default component.exports